import * as React from "react"
const Heart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M11.434 1a4.604 4.604 0 0 0-3.226 1.322L8 2.527l-.208-.205A4.589 4.589 0 0 0 4.566 1 4.589 4.589 0 0 0 1.34 2.322 4.5 4.5 0 0 0 0 5.522a4.5 4.5 0 0 0 1.34 3.2l6.133 6.061a.75.75 0 0 0 1.054 0l6.132-6.06a4.52 4.52 0 0 0 .992-1.467 4.482 4.482 0 0 0-.992-4.934A4.604 4.604 0 0 0 11.433 1z"
    />
  </svg>
)
export default Heart
